export default __webpack_public_path__ + "static/media/translate.d8a49ec6.svg";